import React from 'react'

export const IframeImageMap = ({imageMap}) => {
  if (!imageMap.iframe_url) {
    return <div className="alert alert-danger" role="alert">
      Image map set to iframe but no iframe url set.
    </div>
  }

  return <>
    <style dangerouslySetInnerHTML={{
      __html: `
                html, body {
                  height: 100%;
                  overflow: hidden;
                }
              `
    }}/>
    <iframe allowFullScreen
            src={imageMap.iframe_url}
            style={{paddingBottom: "84px"}}
            className="iframe_fullscreen"
    />
  </>
}
